export const CUSTOM_AUTH_DOMAIN_CACHE_KEY = 'cosmos:custom-auth-domain';

/* System configuration key name */
export const TERMS_URL_KEY = 'terms-and-conditions';
export const PRIVACY_POLICY_URL_KEY = 'privacy';
export const PLATFORM_NAME_KEY = 'platform-name';
export const PLATFORM_TITLE_KEY = 'platform-title';
export const ADMIN_HUB_TITLE_KEY = 'admin-hub-title';
export const PROVIDER_NAME_KEY = 'provider-name';
export const PROJECT_SELECTION_VIEW_KEY = 'project-selection-view';
export const DEVICE_CONNECTIVITY_DOC_KEY = 'device-connectivity-doc';
export const PERSONAL_INFO_FIELD_DISPLAY_FLAG_KEY =
	'personal-info-field-display-flag';
export const PLATFORM_LOGO_SQUARE_LIGHT_KEY = 'platform-logo-square-light';
export const PLATFORM_LOGO_SQUARE_MOON_KEY = 'platform-logo-square-moon';
export const PLATFORM_LOGO_SQUARE_DARK_KEY = 'platform-logo-square-dark';
export const PLATFORM_LOGO_RECTANGLE_LIGHT_KEY =
	'platform-logo-rectangle-light';
export const PLATFORM_LOGO_RECTANGLE_MOON_KEY = 'platform-logo-rectangle-moon';
export const PLATFORM_LOGO_RECTANGLE_DARK_KEY = 'platform-logo-rectangle-dark';
export const PLATFORM_FAV_ICON_KEY = 'platform-fav-icon';
export const PROVIDED_BY_DISPLAY_FLAG_KEY = 'provided-by-display-flag';
export const PROVIDER_LOGO_LIGHT_KEY = 'provider-logo-light';
export const PROVIDER_LOGO_MOON_KEY = 'provider-logo-moon';
export const PROVIDER_LOGO_DARK_KEY = 'provider-logo-dark';
export const BOARDING_SIDE_BANNER_DISPLAY_FLAG_KEY =
	'boarding-side-banner-display-flag';
export const SIDE_BANNER_ALTERNATIVE_IMAGE_KEY =
	'side-banner-alternative-image';
export const BROWSER_SETTINGS_GUIDE_DOC_LINK_KEY =
	'browser-settings-guide-doc-link';
export const MAP_CONFIG_KEY = 'map-config';
export const ALLOW_SELECT_APPEARANCE_MODE = 'allow-select-appearance-mode-flag';
export const PASSWORD_RESTRICTED_KEYWORDS = 'password-restricted-keywords';
